import request from '@/utils/request'
// 获取传入类型和父级编号的下级数据
export const getNextLevelData = (data) => {
    return request.get('/api/sysTreeDict/nextLevelData', data)
}
// 获取临时文件URL
export const getTempFileUrl = (fileId) => {
    return request.get(`/api/file/tmp/url/${fileId}`)
}
//根据fileBindId获取文件列表
export const getFileList = (fileBindId) => {
    return request.get('/api/file/list?fileBindId='+fileBindId)
}


// 通过fileGuid 获取文件下载列表
export const getFileDownloadList = (fileGuid) => {
    return request.get('/api/file/info?fileId='+fileGuid)
}
//根据项目编号 - 获取标段信息
export const getSectionInfoByProjectCode = (projectCode) => {
    return request.get('/api/common/section/info?projectCode='+projectCode)
}

//根据标段编号获取文件信息
export const getInfoBySectionCode = (sectionCode) => {
    return request.get('/api/agent/bidInvitationDocuments/getInfoBySectionCode?sectionCode='+sectionCode)
}
// 监听消息通知topic
export const getMsgTopic = (channelCode) => {
    return request.get('/api/common/msg/topic?channelCode='+channelCode)
}

// 通知消息列表
export const getMsgList = (channelCode) => {
    return request.get('/api/common/index/msg/list?channelCode='+channelCode)
}

// 消息通知详细列表
export const getMsgDetailList = (params) => {
    return request.get('/api/common/msg/list', params)
}


// 根据项目编号获取标段基础信息
export const getSectionBaseInfo = (sectionCode) => {
    return request.get('/api/common/section/base/info?sectionCode=' + sectionCode)
}


// 根据步骤ID判断是否盲标
export const getIsBlindByStepId = (stepId) => {
    return request.get('/api/common/step/is/blind?stepId=' + stepId)
}
// 下载招标文件 word
export const downloadInvitation = (bidSectionCode) => {
    return request.get('/api/bid/make/invitation/download?bidSectionCode=' + bidSectionCode)
}
// 获取提交结束信息
export const getSubmitEndInfo = (sectionCode) => {
    return request.get('/api/common/submit/end?sectionCode=' + sectionCode)
}
// 法人注册
export const expertLegalRegist = (data) => {
    return request.post('/api/ca/expert/legal/regist', data)
}
// 验章
export const verifySeal = (data) => {
    return request.post('/api/ca/expert/verify', data)
}
//获取PDF页码
export const getPdfTotalPages = (data) => {
    return request.get('/api/common/total-pages', data)
}
//根据文件ID获取文件信息
export const getFileInfo = (fileId) => {
    return request.get('/x-file/file/get/' + fileId)
}



